var _slicedToArray = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Wasm =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(raw_wasm, jsglue) {
      _classCallCheck(this, _class);

      this.raw_wasm = raw_wasm;
      this.jsglue = jsglue;
      this.wasm = null;
      this.wasm_memory = null;
    }

    _createClass(_class, [{
      key: "un_init",
      value: function () {
        var _un_init = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "ok"
                  };
                  return _context.abrupt("return", result);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function un_init() {
          return _un_init.apply(this, arguments);
        }

        return un_init;
      }()
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var _this = this;

          var result, wasmModule, wasm, utf8decoder, jsglue, Module;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = {
                    status: "ok"
                  };
                  _context2.prev = 1;

                  if (!(null === this.wasm)) {
                    _context2.next = 20;
                    break;
                  }

                  if (!(null === this.jsglue)) {
                    _context2.next = 14;
                    break;
                  }

                  _context2.next = 6;
                  return new WebAssembly.compile(this.raw_wasm);

                case 6:
                  wasmModule = _context2.sent;
                  _context2.next = 9;
                  return new WebAssembly.instantiate(wasmModule, []);

                case 9:
                  wasm = _context2.sent;
                  this.wasm = wasm.exports;
                  this.wasm_memory = this.wasm.memory;
                  _context2.next = 20;
                  break;

                case 14:
                  utf8decoder = new TextDecoder();
                  jsglue = utf8decoder.decode(this.jsglue);
                  Module = Function('"use strict";' + jsglue + 'return Module;')();
                  _context2.next = 19;
                  return new Promise(function (resolve, reject) {
                    function onRuntimeInitialized() {
                      resolve("onRuntimeInitialized");
                    }

                    _this.wasm = new Module({
                      wasmBinary: _this.raw_wasm,
                      onRuntimeInitialized: onRuntimeInitialized
                    });
                  });

                case 19:
                  this.wasm_memory = this.wasm.wasmMemory;

                case 20:
                  _context2.next = 25;
                  break;

                case 22:
                  _context2.prev = 22;
                  _context2.t0 = _context2["catch"](1);
                  result.status = this.create_error("Exception while init: " + _context2.t0);

                case 25:
                  return _context2.abrupt("return", result);

                case 26:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 22]]);
        }));

        function init() {
          return _init.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "exec",
      value: function () {
        var _exec = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(args) {
          var result, init_res, arg, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, ArgName, ArgValue, arg_index, arg_name_buffer, size, pointer, pWasmData, i, argSize, argPointer, pWasmArgData, j, resSize, resPointer, result_data, pResultData, k;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  result = {
                    status: "",
                    data: []
                  };
                  _context3.prev = 1;
                  _context3.next = 4;
                  return this.init();

                case 4:
                  init_res = _context3.sent;

                  if (!("ok" === init_res.status)) {
                    _context3.next = 62;
                    break;
                  }

                  // fill args
                  arg = 0;
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context3.prev = 10;
                  _iterator = args[Symbol.iterator]();

                case 12:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context3.next = 45;
                    break;
                  }

                  _step$value = _slicedToArray(_step.value, 2), ArgName = _step$value[0], ArgValue = _step$value[1];

                  if (!(null == ArgValue)) {
                    _context3.next = 17;
                    break;
                  }

                  result.status = this.create_error("Wrong usage, one of arguments is empty");
                  return _context3.abrupt("return", result);

                case 17:
                  // lets findout argument index by name
                  arg_index = 0;
                  arg_name_buffer = new TextEncoder("utf-8").encode(ArgName);
                  size = arg_name_buffer.length;
                  pointer = this.wasm._set_arg_name(arg, arg_name_buffer.length);

                  if (!(0 !== pointer)) {
                    _context3.next = 30;
                    break;
                  }

                  pWasmData = new Uint8ClampedArray(this.wasm_memory.buffer, pointer, size);

                  for (i = 0; i < pWasmData.length; i++) {
                    pWasmData[i] = arg_name_buffer[i];
                  }

                  arg_index = this.wasm._get_arg_index(arg);

                  if (!(0 === arg_index)) {
                    _context3.next = 28;
                    break;
                  }

                  result.status = this.create_last_error();
                  return _context3.abrupt("return", result);

                case 28:
                  _context3.next = 32;
                  break;

                case 30:
                  result.status = this.create_last_error();
                  return _context3.abrupt("return", result);

                case 32:
                  // set arg data to Wasm
                  argSize = ArgValue.length;
                  argPointer = this.wasm._set_arg(arg_index, argSize);

                  if (!(0 !== argPointer)) {
                    _context3.next = 39;
                    break;
                  }

                  pWasmArgData = new Uint8ClampedArray(this.wasm_memory.buffer, argPointer, argSize);

                  for (j = 0; j < pWasmArgData.length; j++) {
                    pWasmArgData[j] = ArgValue[j];
                  }

                  _context3.next = 41;
                  break;

                case 39:
                  result.status = this.create_last_error();
                  return _context3.abrupt("return", result);

                case 41:
                  arg++;

                case 42:
                  _iteratorNormalCompletion = true;
                  _context3.next = 12;
                  break;

                case 45:
                  _context3.next = 51;
                  break;

                case 47:
                  _context3.prev = 47;
                  _context3.t0 = _context3["catch"](10);
                  _didIteratorError = true;
                  _iteratorError = _context3.t0;

                case 51:
                  _context3.prev = 51;
                  _context3.prev = 52;

                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }

                case 54:
                  _context3.prev = 54;

                  if (!_didIteratorError) {
                    _context3.next = 57;
                    break;
                  }

                  throw _iteratorError;

                case 57:
                  return _context3.finish(54);

                case 58:
                  return _context3.finish(51);

                case 59:
                  // exec alg in wasm
                  if (this.wasm._exec()) {
                    // get result
                    resSize = this.wasm._get_result_size();
                    resPointer = this.wasm._get_result();

                    if (0 !== resPointer) {
                      result_data = [];
                      pResultData = new Uint8ClampedArray(this.wasm_memory.buffer, resPointer, resSize);

                      for (k = 0; k < pResultData.length; k++) {
                        result_data.push(pResultData[k]);
                      } // TODO:
                      // result["MIME"] = this.wasm._get_result_type();


                      result.status = "ok";
                      result.data = result_data;
                    } else result.status = this.create_last_error();
                  } else result.status = this.create_last_error();

                  _context3.next = 63;
                  break;

                case 62:
                  result.status = this.create_error("Init error: " + init_res.status);

                case 63:
                  _context3.next = 68;
                  break;

                case 65:
                  _context3.prev = 65;
                  _context3.t1 = _context3["catch"](1);
                  result.status = this.create_error("Exception while exec: " + _context3.t1);

                case 68:
                  return _context3.abrupt("return", result);

                case 69:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[1, 65], [10, 47, 51, 59], [52,, 54, 58]]);
        }));

        function exec(_x) {
          return _exec.apply(this, arguments);
        }

        return exec;
      }()
    }, {
      key: "create_error",
      value: function create_error(text) {
        return text;
      }
    }, {
      key: "create_last_error",
      value: function create_last_error() {
        var pointer = this.wasm._get_last_error();

        var size = this.wasm._get_last_error_size();

        var pWasmData = new Uint8ClampedArray(this.wasm_memory.buffer, pointer, size);
        var utf8decoder = new TextDecoder();
        return this.create_error(utf8decoder.decode(pWasmData));
      }
    }]);

    return _class;
  }();
})();